import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Item, ItemsService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-items-by-categoria',
  templateUrl: './items-by-categoria.component.html',
  styleUrls: ['./items-by-categoria.component.scss']
})
export class ItemsByCategoriaComponent implements OnInit {
items: Observable<Item[]>;
  constructor(private itemsservice: ItemsService) { }
cambia(event){
  this.items = this.itemsservice.byCategoria(event.id);
  console.log(event);
}
  ngOnInit() {
  }

}
